<template>
    <div class="orderlist">
        <div class="header">
            <div class="top">
                <span v-for="(item, index) in comData"
                      style="padding:0 10px"
                      @click="tabsClick(item)"
                      :class="curIdx == item.id ? 'isActive' : ''"
                      :key='index'>{{ item.comName }}</span>
            </div>
            <span @click="showPage"
                  style="padding:0 10px">
                <i :class="isShowTrackList
                        ? 'arrow el-icon-arrow-down'
                        : 'arrow el-icon-arrow-right'
                    "></i></span>

        </div>
        <div class="bottom"
             style="background:white"
             v-show="isShowTrackList">
            <keep-alive>
                <component @on-click="onClick"
                           @allSelect="allSelect"
                           @clearMapLine="clearMapLine"
                           :mapController="mapController"
                           :appointmentSiteCodeWhiteList="appointmentSiteCodeWhiteList"
                           v-bind="$attrs"
                           ref="orderList"
                           :is="com"></component>
            </keep-alive>

        </div>
    </div>

</template>

<script>
import OrderList from './OrderList.vue';
import WaybillList from './WaybillList.vue';
import { mutations } from '../store';
export default {
    props: {
        appointmentSiteCodeWhiteList: {
            type: Array,
            default () {
                return [];
            }
        },
        mapController: Object
    },
    data () {
        return {
            isShowTrackList: false,
            com: 'OrderList',
            curIdx: '',
            comData: [
                {
                    comName: '运单列表',
                    com: 'OrderList',
                    id: 0
                },
                {
                    comName: '发车单列表',
                    com: 'WaybillList',
                    id: 1
                }

            ]
        };
    },
    methods: {
        tabsClick (item) {
            this.curIdx = item.id;
            this.com = item.com;
        },
        onClick (val, index, item, totalOrderListData) {
            mutations.clearOlist(true);// 清空运单列表的已选项
            this.$emit('on-click', val, index, item, totalOrderListData);
        },
        allSelect (val, index, data, totalOrderListData) {
            this.$emit('allSelect', val, index, data, totalOrderListData);
        },
        clearMapLine (val) {
            this.$emit('clearMapLine', val);
        },
        showPage () {
            this.isShowTrackList = !this.isShowTrackList;
            this.isShowTrackList ? mutations.retData(true) : mutations.retData(false);
        },
        clearTasks (val) {
            this.$emit('clearTasks');
        }
    },
    components: {
        OrderList,
        WaybillList
    }
};
</script>

<style lang="less">
.orderlist {
    position: absolute;
    top: 50px;
    max-width: 500px;

    .header {
        display: flex;
        justify-content: space-around;
        background: #00bcbe;
        font-size: 14px;
        color: #ffffff7f;
        padding: 10px;
        border-radius: 7px 7px 0 0;
        height: 20px;
        line-height: 20px;
        cursor: pointer;

        .top {
            display: contents;
            justify-content: space-around;
        }
    }
}

.isActive {
    color: #ffffff;
}
</style>
